import Axios from 'axios';

/**
 * https://stackoverflow.com/questions/3452546/how-do-i-get-the-youtube-video-id-from-a-url
 */
export const parseYoutubeVideoID = url => {
  if (!url) {
    return null;
  }
  const videoIDMatch = url.match(/^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]{11}).*/);
  const videoID = videoIDMatch?.[2];
  return videoID || null;
};

/**
 * https://stackoverflow.com/questions/2068344/how-do-i-get-a-youtube-video-thumbnail-from-the-youtube-api
 */
export const getYoutubeVideoThumbnailSrc = url => {
  const videoID = parseYoutubeVideoID(url);
  return videoID ? `https://img.youtube.com/vi/${videoID}/hqdefault.jpg` : undefined;
};

/**
 * https://developer.vimeo.com/api/oembed/videos
 */
export const getVimeoVideoData = async url => {
  if (!url) {
    return null;
  }
  return Axios.get(`https://vimeo.com/api/oembed.json?url=${url}`).then(response => {
    const {
      data
    } = response;
    return {
      videoID: data.video_id,
      thumbnail: data.thumbnail_url
    };
  });
};
export const getVideoData = async src => {
  const youtubeVideoID = parseYoutubeVideoID(src);
  if (youtubeVideoID) {
    return {
      src,
      provider: 'YouTube',
      videoID: youtubeVideoID.toString(),
      thumbnail: getYoutubeVideoThumbnailSrc(src)
    };
  }
  const vimeoVideoData = await getVimeoVideoData(src).catch(() => null);
  if (vimeoVideoData) {
    const {
      videoID,
      thumbnail
    } = vimeoVideoData;
    return {
      src,
      videoID: videoID.toString(),
      thumbnail,
      provider: 'Vimeo'
    };
  }
  return null;
};